import React, { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { api } from "@/lib/api";

const PLATFORM = { trustpilot: "Trustpilot", g2: "G2" };

function formatAsOf(v) {
  const d = new Date(v.length === 7 ? `${v}-01T12:00:00` : `${v}T12:00:00`);
  return isNaN(d) ? v : d.toLocaleDateString("en-US", { month: "long", year: "numeric" });
}

// Hidden until an admin enters a real rating at /admin/site.
export default function ReviewBadgeStrip() {
  const [badge, setBadge] = useState(null);

  useEffect(() => {
    api.get("/site/review-badge").then((r) => setBadge(r.data.badge)).catch(() => {});
  }, []);

  if (!badge) return null;
  const full = Math.round(badge.rating);

  return (
    <a
      href={badge.url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="review-badge-strip"
      className="mt-24 flex flex-wrap items-center gap-x-5 gap-y-2 border-y border-obsidian-600 py-5 max-w-4xl group"
    >
      <span className="flex gap-1" aria-hidden="true">
        {[1, 2, 3, 4, 5].map((i) => (
          <Star key={i} className={`h-4 w-4 ${i <= full ? "fill-terracotta text-terracotta" : "text-obsidian-600"}`} />
        ))}
      </span>
      <span className="font-serif text-xl text-bone-100" data-testid="review-badge-rating">
        {badge.rating.toFixed(1)} on {PLATFORM[badge.platform]}
      </span>
      <span className="font-sans text-sm text-bone-400" data-testid="review-badge-count">
        from {badge.count.toLocaleString()} review{badge.count === 1 ? "" : "s"} · as of {formatAsOf(badge.as_of)}
      </span>
      <span className="font-sans text-xs uppercase tracking-[0.22em] text-terracotta group-hover:text-bone-100 transition-colors">
        Read them →
      </span>
    </a>
  );
}
